import { createStateSelectorHook } from 'src/lib/sweetState';
import { FreestyleToolsStore } from 'src/store';

const useFreestyleToolsState = createStateSelectorHook(FreestyleToolsStore, ['freestyleTools']);

export const useFreestyleTools = () => {
  const { freestyleTools } = useFreestyleToolsState();
  return freestyleTools;
};
